import Form from '../__core/Form';
import component from './component.vue';

export default class FArray extends Form {
  component = component;

  __value = [];

  get items() {
    return this.__value;
  }

  push(item) {
    this.__value.push(item);
    if (item.$subscribe) {
      item.$subscribe(() => {
        this.$dispatch(this);
      });
    }
    this.$dispatch(this);
    return this;
  }

  remove(item) {
    const idx = this.__value.indexOf(item);
    if (idx !== -1) {
      this.__value.splice(idx, 1);
    }
    this.$dispatch(this);
  }

  find(item) {
    return this.items.find(i => i === item);
  }

  clean() {
    this.items.splice(0, -1);
  }

  setItem() {
    return this;
  }

  getItem() {
    return null;
  }

  deleteItem() {
    return this;
  }

  set(value = []) {
    super.set(value);
  }

  get() {
    return this.__items
      .reduce((acc, { key, item }) => {
        acc[key] = item.value;
        return acc;
      }, {});
  }
}
